export const getSessionInfo = function () {
	return fetch('/actions/users/session-info', {
		headers: {
			Accept: 'application/json'
		}
	}).then((response) => response.json())
}

export const isSafariBrowser = () => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export const isFirefoxBrowser = () => {
	return navigator.userAgent.toLowerCase().includes('firefox')
}

export const updateBookingText = () => {
	const slide = document.querySelector('[data-stage="0"]')

	if (!slide) return

	const paragraphs = slide.querySelectorAll('.list-slot__subtitle')
	let pricePattern = /£\d+/g

	paragraphs.forEach(function (paragraph) {
		let content = paragraph.innerHTML

		let newContent = content.replace(pricePattern, function (match) {
			return `<strong>${match}</strong>`
		})

		paragraph.innerHTML = newContent
	})
}

export const addTextToBooking = () => {
	/*
	const slide = document.querySelector('[data-stage="0"]')

	if (!slide) return

	const contents = slide.querySelector('.contents')
	const html = `<h2 class="contents-heading"><span>If you're booking for 20 or more people, please <a href="/contact#form" data-load-prevent>contact us here</a>.</span></h2>`

	contents.insertAdjacentHTML('afterbegin', html)
	*/
}

export default () => { }